import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import { Box, Button, SectionHeader } from 'web-library';
import ErrorPageTitle from '../errors/ErrorPageTitle';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  card: {
    padding: theme.spacing(5),
  },
  backButton: {
    color: theme.color.link.linkDefault01,
  },
  linkAlert: {
     ...typeTheme(theme, 'buttonSmall'),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',
    textAlign: 'center',
    backgroundColor: theme.color.background.bgAlt,
    padding: theme.spacing(11),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(5),
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

export interface AccessMatrixWindowPeriodProps {
  contentBody: string;
  title?: string;
  buttonLabel?: string;
  buttonLink?: string;
}

const AccessMatrixWindowPeriod: React.FC<AccessMatrixWindowPeriodProps> = (
  props: AccessMatrixWindowPeriodProps
) => {
  const { contentBody, title, buttonLabel, buttonLink } = props;
  const { classes } = useStyles();
  const history = useHistory();

  return (
    <>
      {title && <SectionHeader title={title} />}
      <Box className={classes.container}>
        <ErrorPageTitle label={contentBody} />
        {buttonLabel && buttonLink && (
          <Button
            className={classes.backButton}
            variant="text"
            onClick={() => history.push(buttonLink)}
            color="primary"
          >
            {buttonLabel}
          </Button>
        )}
      </Box>
    </>
  );
};
export default AccessMatrixWindowPeriod;
